import { Component, OnInit } from '@angular/core';
import {ResultatService} from '../../services/resultat.service';
import {ResultatData} from '../../shared/models/resultat-data.model';
import {MobileStateService} from '../../services/mobile/mobile-state.service';
import {Subscription} from 'rxjs';
import {Router} from '@angular/router';

@Component({
  selector: 'app-resultat',
  templateUrl: './resultat.page.html',
  styleUrls: []
})
export class ResultatPageComponent implements OnInit {
  subscription: Subscription;

  resultat: ResultatData;

  hasAterbetalningsbelopp = false;

  isMobileResolution = false;
  private isHighTax: boolean;

  constructor(
    private readonly resultatService: ResultatService,
    private readonly mobileStateService: MobileStateService,
    private readonly router: Router,
  ) { }

  ngOnInit() {
    this.isMobileResolution = this.mobileStateService.isMobile();
    this.subscription = this.mobileStateService.isMobile$.subscribe((isMobile: boolean) => {
      this.isMobileResolution = isMobile;
    });

    this.resultat = this.resultatService.getResultat();
    this.hasAterbetalningsbelopp = this.resultatService.hasAterbetalningsbelopp;
  }

  openModal(): void {
    this.resultatService.openNewCalculationModal();
  }

  onPrint(): void {
    this.resultatService.print();
  }

  back() {
    this.router.navigateByUrl('/');
  }

  isWarningHighTax() {
    this.isHighTax = false;
    this.resultat.resultatDtos.forEach((result) => {
      if (result.skattSEK > result.inkomstSEK * .5) {
        this.isHighTax = true;
      }
    });
    return this.isHighTax;
  }
}
